import axios from "axios";

import {
  reducerZipUnloadingsFilters,
  reducerZipUnloadings,
  reducerZipUploadingStatus,
} from "../../reducer/unloadings/reducers/zipUnloadings";
import { AppDispatch } from "../../reducer/store";
import { getToken } from "../axiosToken";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const actionGetZipUnloadings =
  (limit: number, page: number) =>
    async (dispatch: AppDispatch, getState: () => any) => {
      const { token } = await getToken();
      axios.defaults.headers.common["Authorization"] = token;

      const store = getState();
      const filter = store.unloadings.zipUnloadings.zipUnloadingsInputValues;
      try {
        const response = await axios.post(`${BASE_URL}/json/orders/zip`, {
          limit,
          page,
          ...filter,
        });
        dispatch(reducerZipUnloadings({ data: response.data, limit, page: 1 }));
      } catch {
        console.log('err');
      };
    };

export const actionGetZipUnloadingsFilters =
  () => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;
    try {
      const response = await axios.get(`${BASE_URL}/json/orders/zip/filters`);

      dispatch(reducerZipUnloadingsFilters({ data: response.data }));
    } catch {
      console.log('err');
    };
  };

export const actionDeleteZipUnloadings =
  (id: number) =>
    async (dispatch: AppDispatch, getState: () => any) => {
      const { token } = await getToken();
      axios.defaults.headers.common["Authorization"] = token;
      try {
        const response = await axios.delete(`${BASE_URL}/json/orders/delete/zip/${id}`);
        return response;
      } catch {
        dispatch(reducerZipUploadingStatus(0));
      }
    };
